module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="loading_icon">\n\n</div>\n';

}
return __p
}